import React from 'react';
import { useTheme } from '../../context/ThemeContext';

const modes = [
    { id: 'light', label: 'Light mode', icon: 'fa-solid fa-sun' },
    { id: 'dark', label: 'Dark mode', icon: 'fa-solid fa-moon' },
];

/**
 * Light / dark toggle only (preference is global and persisted).
 */
export default function DashboardThemeToggle() {
    const { preference, setPreference } = useTheme();

    return (
        <div
            className="inline-flex items-center gap-0.5 rounded-lg border border-zinc-200 bg-white p-0.5 shadow-sm dark:border-zinc-700 dark:bg-zinc-900/90 dark:shadow-none"
            role="group"
            aria-label="Color theme"
        >
            {modes.map((m) => {
                const active = preference === m.id;
                return (
                    <button
                        key={m.id}
                        type="button"
                        onClick={() => setPreference(m.id)}
                        title={m.label}
                        aria-pressed={active}
                        aria-label={m.label}
                        className={`rounded-md px-2.5 py-1.5 text-[12px] transition-colors ${
                            active
                                ? 'bg-zinc-900 text-white dark:bg-zinc-100 dark:text-zinc-900'
                                : 'text-zinc-500 hover:bg-zinc-100 hover:text-zinc-800 dark:text-zinc-400 dark:hover:bg-zinc-800 dark:hover:text-zinc-100'
                        }`}
                    >
                        <i className={`${m.icon} text-[13px]`} aria-hidden />
                    </button>
                );
            })}
        </div>
    );
}
